const BUSINESS_ID = 'business';
/**
 * To redirect to personal details application
 * @param {string} redirectUri
 * @param {string} businessId
 */
export function redirectToBusinessAccountApp(redirectUri, businessId, navigation) {
  const nav = navigation ? `&navigation=${navigation}` : '';
  const bId = businessId ? `&${BUSINESS_ID}=${businessId}` : '';
  window.location.href = `${decodeURIComponent(redirectUri)}${bId}${nav}`;
}

export const redirectOnExit = (bank_id = 'cb') => {
  const href = `https://uk.virginmoney.com/business`;
  window.location.href = href;
};
